import {docOwnerDefinition} from './nodes/DocOwner';
import {strategyKernelDefinition} from './nodes/StrategyKernel';
import {workingTeamDefinition} from './nodes/WorkingTeam';
import {workstreamTableEmbedDefinition} from './nodes/WorkstreamTableEmbed';
import {registerDynamicNode} from './registry';

registerDynamicNode(docOwnerDefinition);
registerDynamicNode(strategyKernelDefinition);
registerDynamicNode(workingTeamDefinition);
registerDynamicNode(workstreamTableEmbedDefinition);
